import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Avatar, Select, Space } from 'antd';
import { useProfileImage, type FamilyMember, type ViewClaimFilters } from 'all-in-one-shared-api';
import { useKeycloakReady } from 'hooks';
import { UserOutlined } from '@ant-design/icons';

interface Option {
  label: string;
  value: string;
  avatarUrl?: string;
}

interface FamilyMemberDropdownProps {
  defaultMember?: string;
  onChange: React.Dispatch<React.SetStateAction<ViewClaimFilters>>;
  options: FamilyMember[];
}

const { Option } = Select;

const FamilyMemberDropdown = ({ defaultMember, onChange, options }: FamilyMemberDropdownProps) => {
  const { t } = useTranslation();

  const { ready, token } = useKeycloakReady();

  const { shouldFetch: fetchProfileImage, data: profileImageData } = useProfileImage(
    { name: 'getProfileImage', defaultMember },
    token ?? '',
    defaultMember,
  );

  useEffect(() => {
    fetchProfileImage(ready);
  }, [ready, fetchProfileImage]);
  useEffect(() => {
    console.log(defaultMember, 'FamilyMemberDropdown的useEffect');
  }, [defaultMember]);
  const selectOptions: Option[] = useMemo(() => {
    return [
      {
        label: t(`myClaims.allMembers`),
        value: defaultMember || '',
      },
      ...options.map((a) => ({
        label: `${a.firstName} ${a.lastName}`,
        value: a.memberType || '',
        avatarUrl: profileImageData?.find((data) => a.memberType === data.memberType)?.pictureUrl ?? 'default',
      })),
    ];
  }, [defaultMember, options, t, profileImageData]);

  function handleFamilyMemberChange(value: string) {
    console.log(defaultMember, 'FamilyMemberDropdown的onChange');
    onChange((state) => {
      return {
        ...state,
        patientMemberTypes: value.split(','),
      };
    });
  }

  return (
    <Select
      disabled={(options || []).length == 0}
      defaultValue={defaultMember}
      style={{ width: 210 }}
      defaultActiveFirstOption={true}
      placeholder={t(`myClaims.allMembers`)}
      onChange={handleFamilyMemberChange}
    >
      {selectOptions.map((option) => (
        <Option key={option.value}>
          <Space>
            {option.avatarUrl &&
              (option.avatarUrl === 'default' ? (
                <Avatar size="small" icon={<UserOutlined />} />
              ) : (
                <Avatar size="small" src={option.avatarUrl} />
              ))}
            {option.label}
          </Space>
        </Option>
      ))}
    </Select>
  );
};

export default FamilyMemberDropdown;
